"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
var _lhJsEmailContentLib = require("@lifehikes/lh-js-email-content-lib");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _log = require("@/utils/log");
var _SupportedPlaceholders = _interopRequireDefault(require("./SupportedPlaceholders.vue"));
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'HikeEmailSetting',
  components: {
    Tinymce: _Tinymce.default,
    SupportedPlaceholders: _SupportedPlaceholders.default
  },
  props: {
    parentId: {
      type: String,
      default: ""
    },
    parentAutomatedEmail: {
      type: Array,
      default: []
    },
    parentEmailRuleSet: {
      type: String,
      default: _lhJsEmailContentLib.ruleSetNames.HIKE_EMAIL_RULE_SET_NO_EMAIL
    },
    parentRelatedLoops: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      hikeRuleSets: _lhJsEmailContentLib.hikeRuleSets,
      ruleSet: _lifehikesInitData.RuleSet,
      emailRuleSet: "",
      emailSetting: []
    };
  },
  computed: {
    haveLoop() {
      return Array.isArray(this.parentRelatedLoops) && this.parentRelatedLoops.length > 0;
    }
  },
  watch: {
    emailRuleSet: {
      handler(newVal) {
        this.passBackToParent(newVal, "ruleSet");
      },
      deep: true
    },
    emailSetting: {
      handler(newVal) {
        const newEmailSetting = newVal.map(p => {
          return {
            ruleName: p.name,
            subject: p.defaultSubject,
            content: p.defaultContent
          };
        });
        console.info('newEmailSetting');
        console.info(newEmailSetting);
        this.passBackToParent(newEmailSetting, "emailSetting");
      },
      deep: true
    }
  },
  async created() {
    if (this.parentEmailRuleSet === "" || this.parentEmailRuleSet === null) {
      this.emailRuleSet = _lhJsEmailContentLib.ruleSetNames.HIKE_EMAIL_RULE_SET_NO_EMAIL;
    } else {
      this.emailRuleSet = this.parentEmailRuleSet;
    }
    this.initEmailSetting(false);
  },
  methods: {
    initEmailSetting(refreshEditor) {
      this.emailSetting = [];
      const selectRule = this.emailRuleSet;
      const hikeRuleSets = this.hikeRuleSets[selectRule];
      console.info(selectRule);
      console.info(hikeRuleSets);
      hikeRuleSets.forEach(item => {
        const emailSetting = (0, _lhJsEmailContentLib.getEmailRuleSettings)(item);
        const parentEmailSetting = this.parentAutomatedEmail.find(p => p.ruleName === item);
        if (parentEmailSetting !== null && parentEmailSetting !== undefined) {
          emailSetting.defaultSubject = parentEmailSetting.subject;
          emailSetting.defaultContent = parentEmailSetting.content;
        }
        emailSetting.name = item;
        emailSetting.showPlaceholders = false;
        let remarks = '';
        if (this.haveLoop) {
          if (!emailSetting.enableWhenHikeInLoop) {
            remarks = "It will not trigger because the Hike is within a Loop.";
          }
        } else {
          if (!emailSetting.enableWhenHikeNotInLoop) {
            remarks = "It will not trigger because the Hike is not within a Loop.";
          }
        }
        emailSetting.remarks = remarks;
        console.log(emailSetting);
        this.emailSetting.push(emailSetting);
      });
      if (refreshEditor) {
        this.$nextTick(() => this.emailSetting.forEach((item, index) => {
          console.info('当前---------------：' + index);
          //console.info(item.defaultContent);
          this.resetSubjectContent(item.name, index);
        }));
      }
      console.log(this.emailSetting);
    },
    ruleSettingChange() {
      this.initEmailSetting(true);
    },
    resetSubjectContent(name, index) {
      //console.info('当前name---------------：' + name)
      const defaultEmailSetting = (0, _lhJsEmailContentLib.getEmailRuleSettings)(name);
      let currentSetting = this.emailSetting[index];
      //console.info('defaultEmailSetting---------------：' + defaultEmailSetting)
      //console.info('currentSetting---------------：' + currentSetting)
      currentSetting.defaultSubject = defaultEmailSetting.defaultSubject;
      currentSetting.defaultContent = defaultEmailSetting.defaultContent;
      //this.$set(this.emailSetting, index, currentSetting)
      //Fixed the tinymce editor reset update ui bug
      this.$nextTick(() => {
        const editor = window.tinymce && window.tinymce.get("descriptionEditor" + index);
        if (editor) {
          return editor.setContent(currentSetting.defaultContent || "");
        } else {
          console.warn("TinyMCE editor instance not found yet for ID: descriptionEditor" + index);
        }
      });
    },
    switchPlaceholders(showPlaceholders, index) {
      let currentSetting = this.emailSetting[index];
      currentSetting.showPlaceholders = showPlaceholders;
    },
    passBackToParent(res, type) {
      this.$emit("updateParentEmailRuleSet", res, type);
    }
  }
};